export default __webpack_public_path__ + "static/media/appstore.3a0a4077.svg";